"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginForm = void 0;
var mdbreact_1 = require("@aon/mdbreact");
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var ApplicationLogo_1 = require("../ApplicationLogo");
var Common_1 = require("../Common");
var LoginFormWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: inline-block;\n\tmargin-top: 150px;\n\ttext-align: left;\n\tmargin-bottom: 13.5px;\n"], ["\n\tdisplay: inline-block;\n\tmargin-top: 150px;\n\ttext-align: left;\n\tmargin-bottom: 13.5px;\n"])));
LoginFormWrapper.displayName = 'LoginFormWrapper';
var AppLogoLogin = (0, styled_components_1.default)(ApplicationLogo_1.ApplicationLogo)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tmargin-left: 0px;\n"], ["\n\tmargin-left: 0px;\n"])));
AppLogoLogin.displayName = 'AppLogoLogin';
var CardHeader = (0, styled_components_1.default)(mdbreact_1.CardHeader)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tpadding: 60px !important;\n"], ["\n\tpadding: 60px !important;\n"])));
CardHeader.displayName = 'CardHeader';
var CardTitle = (0, styled_components_1.default)(mdbreact_1.CardTitle)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tmax-height: 70px;\n\tvertical-align: middle;\n"], ["\n\tmax-height: 70px;\n\tvertical-align: middle;\n"])));
CardTitle.displayName = 'CardTitle';
var WelcomeText = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\tfont-size: 12px;\n"], ["\n\tfont-size: 12px;\n"])));
var CardBody = (0, styled_components_1.default)(mdbreact_1.CardBody)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\tpadding: 0px !important;\n"], ["\n\tpadding: 0px !important;\n"])));
CardBody.displayName = 'CardBody';
var InputUsername = (0, styled_components_1.default)(Common_1.Input).attrs({
    type: 'text',
    id: 'intUsername',
    required: true,
})(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n\tmargin-bottom: 20px;\n\theight: 48px;\n\twidth: 350px;\n\tdisplay: table-row;\n\tmargin-bottom: ", ";\n\t+ p {\n\t\tmargin-bottom: 30px;\n\t}\n"], ["\n\tmargin-bottom: 20px;\n\theight: 48px;\n\twidth: 350px;\n\tdisplay: table-row;\n\tmargin-bottom: ", ";\n\t+ p {\n\t\tmargin-bottom: 30px;\n\t}\n"])), function (props) { return (props.error ? '30px' : '0px'); });
InputUsername.displayName = 'InputUsername';
var LabelUsername = styled_components_1.default.label(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n\tfont-size: 13px;\n\tfont-weight: 600;\n\tcolor: #444444;\n\tmargin-bottom: 10px;\n\tmargin-top: 60px;\n"], ["\n\tfont-size: 13px;\n\tfont-weight: 600;\n\tcolor: #444444;\n\tmargin-bottom: 10px;\n\tmargin-top: 60px;\n"])));
LabelUsername.displayName = 'LabelUsername';
var InputPassword = (0, styled_components_1.default)(Common_1.Input).attrs({
    type: 'password',
    id: 'intPassword',
    required: true,
})(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n\theight: 48px;\n\twidth: 350px;\n\tdisplay: table-row;\n\tmargin-bottom: ", ";\n\t+ p {\n\t\tmargin-bottom: 30px;\n\t}\n"], ["\n\theight: 48px;\n\twidth: 350px;\n\tdisplay: table-row;\n\tmargin-bottom: ", ";\n\t+ p {\n\t\tmargin-bottom: 30px;\n\t}\n"])), function (props) { return (props.error ? '30px' : '0px'); });
InputPassword.displayName = 'InputPassword';
var LabelPassword = styled_components_1.default.label(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n\tfont-size: 13px;\n\tfont-weight: 600;\n\tcolor: #444444;\n\tmargin-bottom: 10px;\n"], ["\n\tfont-size: 13px;\n\tfont-weight: 600;\n\tcolor: #444444;\n\tmargin-bottom: 10px;\n"])));
LabelPassword.displayName = 'LabelPassword';
var LoginButton = (0, styled_components_1.default)(Common_1.Button).attrs({})(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n\tmargin-bottom: 60px !important;\n\tfloat: right;\n"], ["\n\tmargin-bottom: 60px !important;\n\tfloat: right;\n"])));
LoginButton.displayName = 'LoginButton';
var FormLogin = styled_components_1.default.form.attrs({
    id: 'formLogin',
    method: 'post',
})(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n\tmargin-left: 60px;\n\tmargin-right: 60px;\n"], ["\n\tmargin-left: 60px;\n\tmargin-right: 60px;\n"])));
FormLogin.displayName = 'FormLogin';
var LoginForm = /** @class */ (function (_super) {
    __extends(LoginForm, _super);
    function LoginForm(props) {
        var _this = _super.call(this, props) || this;
        _this.onLoginClick = function (event) {
            event.preventDefault();
            if (!_this.state.userName || !_this.state.password) {
                if (_this.state.userName === '' || _this.state.userName === undefined) {
                    _this.setState({ userNameError: 'please enter username' });
                }
                else {
                    _this.setState({ userNameError: '' });
                }
                if (_this.state.password === '' || _this.state.password === undefined) {
                    _this.setState({ passwordError: 'please enter password' });
                }
                else {
                    _this.setState({ passwordError: '' });
                }
            }
            else {
                _this.setState({ userNameError: '', passwordError: '' });
                _this.props.onLoginClick();
            }
        };
        _this.onUsernameChange = function (event) {
            _this.setState(__assign(__assign({}, _this.state), { userName: event.target.value }));
        };
        _this.onPasswordChange = function (event) {
            _this.setState(__assign(__assign({}, _this.state), { password: event.target.value }));
        };
        _this.state = {
            userNameError: '',
            passwordError: '',
            userName: '',
            password: '',
        };
        return _this;
    }
    LoginForm.prototype.render = function () {
        return (React.createElement(LoginFormWrapper, null,
            React.createElement(Common_1.Card, null,
                React.createElement(CardHeader, null,
                    React.createElement(AppLogoLogin, { logoSrc: this.props.appLogoSrc }),
                    React.createElement(CardTitle, null,
                        React.createElement(WelcomeText, null, "Welcome to"),
                        this.props.appName)),
                React.createElement(CardBody, null,
                    React.createElement(FormLogin, { noValidate: true },
                        React.createElement(LabelUsername, null, "Username"),
                        React.createElement(InputUsername, { value: this.state.userName, onChange: this.onUsernameChange, error: true, message: this.state.userNameError, required: true }),
                        React.createElement(LabelPassword, null, "Password"),
                        React.createElement(InputPassword, { value: this.state.password, onChange: this.onPasswordChange, error: true, message: this.state.passwordError, required: true }),
                        React.createElement(LoginButton, { onClick: this.onLoginClick, color: 'primary', size: 'sm' }, "Log In"))))));
    };
    return LoginForm;
}(React.Component));
exports.LoginForm = LoginForm;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;
